module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "C593"
  }, [_c('span', {
    staticClass: "size_145"
  }, [_c('span', {
    staticClass: "color_0B0E11"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "id_4"
    }
  }, [_vm._v("Pattern")]), _vm._v(" and Texture")])])])]), _vm._v(" "), _c('p', {
    staticClass: "C580"
  }, [_vm._v("Textural elements in your design create depth, structure, and a wonderful tactile feature in your quilt. This can be achieved with printed or textured fabrics, with the quilting stitches, or with both. Pattern and texture should complement each other to enhance your design, to communicate a message, and to add subtle detail and interest. Find a balance in these elements; too much pattern or texture can be visually and emotionally overwhelming, and not enough is uninteresting. People respond viscerally to these elements because they evoke emotion and create feelings of harmony.")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "C580"
  }, [_vm._v("In "), _c('em', [_vm._v("Frothy Nothing")]), _vm._v(", the quilting adds the textural element.")]), _vm._v(" "), _c('p', {
    staticClass: "C572"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "img/15_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "C694"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Frothy Nothing ("), _c('span', {
    attrs: {
      "href": "#/xhtml/34_Frothy_N#page_114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 114")]), _vm._v("), detail")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8daee22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/11___Patter.vue
// module id = 84
// module chunks = 0